<svelte:head>
  <title>404</title>
</svelte:head>

<h1>404 Not Found</h1>